import { render, staticRenderFns } from "./VehicleService.vue?vue&type=template&id=4555f7a6&"
import script from "./VehicleService.vue?vue&type=script&lang=js&"
export * from "./VehicleService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports